import { useState } from "react";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { QRCodeSVG } from "qrcode.react";
import { SITE } from "../config";
import { track } from "../lib/analytics";

const AppleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" /></svg>
);

const PlayIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3.6 2.3c-.36.19-.6.57-.6 1.05v17.3c0 .48.24.86.6 1.05l9.67-9.7L3.6 2.3zm11.13 8.24L5.6 1.42l11.6 6.67-2.47 2.45zm3.93-1.4c.75.43.75 1.29 0 1.72l-2.47 1.42-2.72-2.28 2.72-2.28 2.47 1.42zM5.6 22.58l9.13-9.12 2.47 2.45L5.6 22.58z" /></svg>
);

export const StoreButtons = ({ placement = "hero", className = "" }) => (
  <div className={`flex flex-col sm:flex-row gap-3 ${className}`} data-testid={`${placement}-store-buttons`}>
    <a
      href={SITE.googlePlayUrl}
      target="_blank"
      rel="noreferrer"
      data-testid={`${placement}-google-play-btn`}
      onClick={() => track(`${placement}_google_play_clicked`)}
      className="v2-store-btn v2-store-live"
      aria-label="Download HUMN on Google Play"
    >
      <PlayIcon />
      <span><small>LIVE · GET IT ON</small><strong>Google Play</strong></span>
    </a>
    <button
      type="button"
      disabled
      data-testid={`${placement}-app-store-btn`}
      className="v2-store-btn v2-store-disabled"
      aria-label="Coming soon on the App Store"
    >
      <AppleIcon />
      <span><small>COMING SOON ON THE</small><strong>App Store</strong></span>
    </button>
  </div>
);

export const QRButton = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button data-testid="qr-open-btn" onClick={() => setOpen(true)} className={`text-sm underline underline-offset-4 tx-2 ${className}`}>Scan QR to download</button>
      {createPortal(
        <AnimatePresence>{open && (
          <motion.div role="dialog" aria-modal="true" aria-label="Google Play QR code" data-testid="qr-modal" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-lg p-6" onClick={() => setOpen(false)}>
            <motion.div initial={{ scale: .92, y: 16 }} animate={{ scale: 1, y: 0 }} className="bg-white rounded-2xl p-9 text-center max-w-xs w-full" onClick={(event) => event.stopPropagation()}>
              <img src="/brand/humn-wordmark.png" alt="HUMN" className="h-5 w-auto mx-auto mb-5" />
              <div className="inline-block p-4 bg-white border border-black/10 rounded-xl"><QRCodeSVG value={SITE.googlePlayUrl} size={164} /></div>
              <p className="text-black text-sm font-semibold mt-5">HUMN is live on Google Play</p>
              <button data-testid="qr-close-btn" onClick={() => setOpen(false)} className="mt-5 px-6 py-2 rounded-full bg-black text-white text-sm">Close</button>
            </motion.div>
          </motion.div>
        )}</AnimatePresence>,
        document.body
      )}
    </>
  );
};